"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var roles_1 = require("../constants/roles");
function highestRole(roles, heirarchy) {
    if (roles === void 0) { roles = []; }
    if (heirarchy === void 0) { heirarchy = roles_1.ORGANISATION_ROLE_HEIRARCHY; }
    return sortRoles(roles, heirarchy)[0];
}
exports.highestRole = highestRole;
function lowestRole(roles, heirarchy) {
    if (roles === void 0) { roles = []; }
    if (heirarchy === void 0) { heirarchy = roles_1.ORGANISATION_ROLE_HEIRARCHY; }
    return sortRoles(roles, heirarchy).reverse()[0];
}
exports.lowestRole = lowestRole;
function sortRoles(roles, inHeirarchy) {
    if (roles === void 0) { roles = []; }
    if (inHeirarchy === void 0) { inHeirarchy = roles_1.ORGANISATION_ROLE_HEIRARCHY; }
    var roleValues = inHeirarchy.reduce(function (a, b, idx) {
        return (__assign({}, a, (_a = {}, _a[b] = idx, _a)));
        var _a;
    }, {});
    return roles
        .filter(function (val) { return inHeirarchy.indexOf(val) >= 0; })
        .sort(function (a, b) { return roleValues[a] - roleValues[b]; });
}
exports.sortRoles = sortRoles;
